import * as types from "./actionsTypes";
import * as API from "../utils/apiPath";
import { agent } from "../utils/agent";
import submittingRequestStatus from "./submittingRequestStatusAction";

export function PostResurcesHubDataSuccess(PostResourcesHubData) {
  return { type: types.SAVE_RESOURCES_DATA_SUCCESS, PostResourcesHubData };
}
export function loadResourcesHubDataSuccess(ResourcesHubData) {
  return { type: types.LOAD_RESOURCES_HUB_DATA_SUCCESS, ResourcesHubData };
}
export function loadNewsletterDataSuccess(NewsletterData) {
  return { type: types.LOAD_NEWSLETTER_DATA_SUCCESS, NewsletterData };
}
export function loadVideoDataSuccess(VideoData) {
  return { type: types.LOAD_VIDEO_DATA_SUCCESS, VideoData };
}

// export function PostResurcesHubData(formData) {
//   return async function (dispatch) {
//     dispatch(submittingRequestStatus(true));
//     await agent
//       .post(API.SAVE_RESOURCES_HUB, formData, {
//         headers: {
//           'Content-Type': undefined // Let the browser set the boundary for multipart/form-data
//         }
//       })
//       .then((response) => {
        
//         if (response.status === 503) 
//         {
//           dispatch(submittingRequestStatus(false));
//         }
//         if (response.status === 422) 
//         {
//         }
//         if (response.status === 200) 
//         {
//           dispatch(submittingRequestStatus(false));
//           dispatch(PostResurcesHubDataSuccess(true));
//           dispatch({
//             type: "REDIRECT",
//             payload: "resource-hub/all-posts",
//           });
//         }
//       })
//       .catch((error) => {
//         dispatch(submittingRequestStatus(false));
//       });
//   };
// }

export function PostResurcesHubData(formData) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));

    try {
      const response = await agent.post(API.SAVE_RESOURCES_HUB, formData, {
        headers: {
          'Content-Type': undefined // Let browser set multipart boundary
        }
      });

      dispatch(submittingRequestStatus(false));

      // ✅ Return server response so component handles popup
      return response.data;

    } catch (error) {
      dispatch(submittingRequestStatus(false));
      // ✅ Return error object for popup handling
      return {
        status: error?.response?.status || 500,
        message: error?.response?.data?.message || "An unexpected error occurred.",
      };
    }
  };
}

export function PostCKEditorData(formData) {
  return async function (dispatch) {
    dispatch(submittingRequestStatus(true));
    await agent
      .post(API.CKEDITOR_IMAGE_UPLOAD, formData)
      .then((response) => {
        if (response.status === 503) 
        {
          dispatch(submittingRequestStatus(false));
        }
        if (response.status === 200) 
        {
          dispatch(submittingRequestStatus(false));
          dispatch(PostResurcesHubDataSuccess(true));
        
        }
      })
      .catch((error) => {
        dispatch(submittingRequestStatus(false));
      });
  };
}

export function loadResourcesHubData(request,id) {
  return async function (dispatch) {
    dispatch(loadResourcesHubDataSuccess(true));
    await agent
      .post(API.RESOURCES_HUB_DATA +
        "/" +
        request.category, {
          params: request,
        })
      .then((response) => {
        dispatch(loadResourcesHubDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadNewsletterData() {
  return async function (dispatch) {
    dispatch(loadNewsletterDataSuccess(true));
    await agent
      .post(API.NEWSLETTER_DATA , { })
      .then((response) => {
        dispatch(loadNewsletterDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadVideoData() {
  return async function (dispatch) {
    dispatch(loadVideoDataSuccess(true));
    await agent
      .post(API.VIDEO_DATA , { })
      .then((response) => {
        dispatch(loadVideoDataSuccess(response.data.data));
      })
      .catch((error) => {
        throw error;
      });
  };
}


